'use client'

import { NavigationSidebarItemsBottom } from '../NavigationSidebarItemsBottom/NavigationSidebarItemsBottom'
import { NavigationSidebarItemsTop } from '../NavigationSidebarItemsTop/NavigationSidebarItemsTop'
import { useGlobalSettingsStore } from '@repo/store/useGlobalSettingsStore'
import { useMenuItemsStore } from '@repo/store/useMenuItemsStore'
import { useNavigationStore } from '@repo/store/useNavigationStore'
import { useWindowSize } from '@uidotdev/usehooks'
import { useEffect } from 'react'
import MUIStack from '@mui/material/Stack'

export const NavigationSidebar = () => {
  const { sidebarMode, sidebarBreakpoint } = useGlobalSettingsStore()
  const { setMenuPanels, setPanelHeadings, setOpen } = useNavigationStore()
  const { closeMainNavigationMenu } = useMenuItemsStore()
  const { width: windowWidth } = useWindowSize()

  useEffect(() => {
    // if the window is less than 1280px, set the sidebar mode to closed
    // additionally, there is a breakpoint set on the NavigationSidebarModeSwitcher component to hide the toggle button below this breakpoint
    if (windowWidth < sidebarBreakpoint && sidebarMode !== 'closed') {
      useGlobalSettingsStore.setState({ sidebarMode: 'closed' })
    }
  }, [windowWidth, sidebarMode, sidebarBreakpoint])

  const closeMenu = () => {
    setMenuPanels(null)
    setPanelHeadings(null)
    closeMainNavigationMenu()
    setOpen(false)
  }

  return (
    <MUIStack
      direction={'column'}
      alignItems="flex-start"
      justifyContent="space-between"
      onMouseLeave={(e) => {
        const to = e.relatedTarget
        const menuEl = document.getElementById('MainNavigationMenu')
        if (menuEl && to instanceof Node && menuEl.contains(to)) return

        closeMenu()
      }}
      sx={{
        backgroundColor: 'primary.main',
        width: sidebarMode === 'expanded' ? '264px' : '64px',
        minHeight: '500px',
        height: '100%',
        padding: '4px 0px 22px',
        position: 'fixed',
        zIndex: 11,
        top: 0,
        left: 0,
        transition: 'width 250ms',
        overflow: 'hidden'
      }}
    >
      <NavigationSidebarItemsTop />
      <NavigationSidebarItemsBottom />
    </MUIStack>
  )
}
